<template lang="pug">
v-container(v-bind="$attrs" :class="sizeClasses").k-container
  slot
</template>

<script>
import { Sizeable } from '@/mixins'

export default {
  mixins: [
    Sizeable
  ]
}
</script>

<style lang="scss" scoped>
.container.k-container {

  max-width: 100%;
  padding: 18px;

  @include sm-and-up {
    padding: 21px;
  }
  @include md-and-up {
    padding: 28px;
  }
  @include lg-and-up {
    padding: 36px;
    width: 1200px;
  }

  &--small {
    @include sm-and-up {
      padding: 15px 30px;
      width: 650px;
    }
    @include md-and-up {
      padding: 20px 50px;
      width: 750px;
    }
    @include lg-and-up {
      padding: 30px 150px;
      width: 1140px;
    }
  }

  &--x-small {
    @include sm-and-up {
      padding: 15px 40px;
      width: 600px;
    }
    @include md-and-up {
      padding: 20px 50px;
      width: 750px;
    }
    @include lg-and-up {
      padding: 30px 75px;
      width: 900px;
    }
  }
}
</style>
